export default __webpack_public_path__ + "assets/b840afc431e17059679e305a0f8ffbaf.svg";